import customAxios from '../../customAxios';

import { FinancialCompanyNamespace } from '../../../types/financiallCompany.namespace';
import { COMPANY_GET_FACTORS_IS_NEED_PAY_2_COMPANY } from '../../routes';

const approveparentTransaction = async (props: FinancialCompanyNamespace.getFactorsIsNeedPay2Company) => {
  let thisUrl = COMPANY_GET_FACTORS_IS_NEED_PAY_2_COMPANY + '?';

  if (props?.page     ) thisUrl += `&page=${props.page}`;
  if (props?.limit    ) thisUrl += `&limit=${props.limit}`;
  if (props?.endAt    ) thisUrl += `&endAt=${props.endAt}`;
  if (props?.payerType) thisUrl += `&payerType=${props.payerType}`;

  if (props?.isPaid2Company !== undefined) thisUrl += `&isPaid2Company=${props.isPaid2Company}`;

  // ?? Academic year (سال تحصیلی) scope
  if (props?.academicYear) thisUrl += `&academicYear=${props.academicYear}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ COMPANY_GET_FACTORS_IS_NEED_PAY_2_COMPANY: error });
  }
};

export default approveparentTransaction;
